import PaginatedReportsTab from '../../components/paginated-reports-tab';

export default function ReportsTab() {
  return (
    <PaginatedReportsTab
      unifiedBenefits
      showReportType
      withoutCard
      benefitCountLabel="Quantidade de benefícios"
      errorLabel="benefícios"
    />
  );
}
